module.exports = __webpack_public_path__ + "img/edit.22e58080.svg";